import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainHomeComponent } from './components/main-home/main-home.component';
import { SignedInGuard } from './helpers/guards/signed-in.guard';
import { SignedOutGuard } from './helpers/guards/signed-out.guard';
import { AppLayoutComponent } from './layout/app.layout.component';
import { DemandeResiliationComponent } from './components/demande-resiliation/demande-resiliation.component';
import { NousContacterComponent } from './components/nous-contacter/nous-contacter.component';
import { SuiviDemandesComponent } from './components/suivi-demandes/suivi-demandes.component';
import { FaqComponent } from './components/faq/faq.component';
import { MesCourriersComponent } from './components/mes-courriers/mes-courriers.component';
import { GestionSalariesComponent } from './components/gestion-salaries/gestion-salaries.component';
import { MesContratsComponent } from './components/mes-contrats/mes-contrats.component';
import { CotisationsComponent } from './components/cotisations/cotisations.component';
import { MesServicesComponent } from './components/mes-services/mes-services.component';

import { CoordonneesBancairesComponent } from "./components/coordonnees-bancaires/coordonnees-bancaires.component";
import { DocumentsContractuelsComponent } from "./components/documents-contractuels/documents-contractuels.component";
import { MonProfilComponent } from './components/mon-profil/mon-profil.component';
import { SuiviDemandeAdhesionComponent } from './components/suivi-demande-adhesion/suivi-demande-adhesion.component';
import { AlertsDsnComponent } from './components/alerts-dsn/alerts-dsn.component';
import {SubscriptionComponent} from "./components/subscription/subscription.component";
import { MereFilialeComponent } from './components/mere-filiale/mere-filiale.component';
import { DocumentsDsnComponent } from './components/documents-dsn/documents-dsn.component';
import {GestionCabinetsComptablesComponent} from "./components/gestion-cabinets-comptables/gestion-cabinets-comptables.component";
import {AcceptedCguGuard} from "./helpers/guards/acceptedCguGuard";
import { ConsentGuard } from './helpers/guards/consent.guard';
import { CookieErrorComponent } from './components/cookie-consent-error-page/cookie-error.component';

const routes: Routes = [

  {
    path: '', component: AppLayoutComponent, canActivate: [SignedInGuard] , canActivateChild: [SignedInGuard,ConsentGuard],
    children: [
      {
        path: '', redirectTo: 'accueil', pathMatch: 'full'
      },
      {
        path: 'accueil', component: MainHomeComponent, canActivate: [AcceptedCguGuard]
      },
      {
        path: 'nous-contacter', component: NousContacterComponent
      },
      {
        path: 'suivi-des-demandes', component: SuiviDemandesComponent,
      },
      {
        path: 'faq', component: FaqComponent
      },
      {
        path: 'mes-courriers', component: MesCourriersComponent
      },
      {
        path: 'demande-resiliation', component: DemandeResiliationComponent
      },
      {
        path: 'gestion-salaries', component: GestionSalariesComponent
      },
      {
        path: 'service', component: MesServicesComponent
      },
      {
        path: 'mon-profil', component: MonProfilComponent
      },
      {
        path: 'documents-contractuels', component: DocumentsContractuelsComponent
      },
      {
        path: 'coordonnees-bancaires', component: CoordonneesBancairesComponent
      },
      {
        path: 'suivi-demande-adhesion', component: SuiviDemandeAdhesionComponent
      },
      {
        path: 'mes-contrats', component: MesContratsComponent
      },
      {
        path: 'alertes-dsn', component: AlertsDsnComponent
      },
      {
        path: 'cotisations', component: CotisationsComponent
      },
      {
        path: 'gestion-filiale', component: MereFilialeComponent
      },
      {
        path: 'documents-dsn', component: DocumentsDsnComponent
      },
      {
        path: 'mes-cabinets-comptables', component: GestionCabinetsComptablesComponent
      },

    ]
  },
  { path: 'access-denied', loadChildren: () => import('./components/auth/accessdenied/accessdenied.module').then(m => m.AccessdeniedModule)},
  { path: 'auth', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),canActivate: [SignedOutGuard]},
  { path: 'affichage-cgu', loadChildren: () => import('./components/affichage-cgu/affichage-cgu.module').then(m => m.AffichageCguModule), canActivate: [SignedInGuard]},
  { path: 'subscription', component: SubscriptionComponent},
  { path: 'cookie-error', component: CookieErrorComponent },
  { path: '**', redirectTo: 'auth/login', pathMatch: 'full'},

];
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
